import type { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';
import { dehydrate, QueryClient } from '@tanstack/react-query';

import g from 'src/constants/urls';
import { IArticleByGroupDetail } from 'src/interface/ArticleByGroup';
import wrapper from 'src/redux';
import { generateBreadcrumbArray } from 'src/utils/ConvertSlug';

const HeadC = dynamic(() => import('src/components/Head'));
const ArticleContainerPraKehamilan = dynamic(() => import('src/containers/PraKehamilan'));
// const ArticleDownloadContainer = dynamic(() => import('src/containers/Download/Articles'));

const CategoryArticle = (props: any) => {
	const phase = props.phase;
	const category = props.category;
	const categorySelected = props.categorySelected;
	const filterCategory = category.find((cat: any) => cat.slug === categorySelected);

	return (
		<>
			<HeadC
				title={
					phase === 'pra-kehamilan' ?
						(filterCategory && filterCategory.meta_title ? filterCategory.meta_title : 'Kumpulan Tips Program Hamil dan Persiapan Kehamilan Sehat') :
						phase === 'kehamilan' ?
							(filterCategory && filterCategory.meta_title ? filterCategory.meta_title : 'Panduan Lengkap Kehamilan Sehat dan Tips untuk Ibu Hamil') :
							phase === 'pasca-kehamilan' ?
								(filterCategory && filterCategory.meta_title ? filterCategory.meta_title : 'Tips Perawatan Pasca Melahirkan, Bayi Baru Lahir & Parenting') :
								'Kumpulan Tips Program Hamil dan Persiapan Kehamilan Sehat'
				}
				description={
					phase === 'pra-kehamilan' ?
						(filterCategory && filterCategory.meta_description ? filterCategory.meta_description :
							'Temukan artikel, tips, dan panduan lengkap persiapan kehamilan yang sehat' +
							' di HalloBumil. Bantu calon ibu mempersiapkan tubuh dan mental secara optimal.') :
						phase === 'kehamilan' ?
							(filterCategory && filterCategory.meta_description ? filterCategory.meta_description :
								'Dapatkan tips dan panduan setiap trimester serta dukungan untuk ' +
								'menjaga kesehatan ibu dan bayi selama kehamilan. ' +
								'Temukan semua informasi di Hallobumil.') :
							phase === 'pasca-kehamilan' ?
								(filterCategory && filterCategory.meta_description ? filterCategory.meta_description :
									'Dapatkan panduan lengkap perawatan pasca melahirkan, ' +
									'tips kesehatan ibu, perawatan bayi, dan parenting di HalloBumil. ' +
									'Yuk dukung perjalanan baru jadi orang tua!') :
								'Temukan artikel, tips, dan panduan lengkap persiapan kehamilan yang sehat' +
								' di HalloBumil. Bantu calon ibu mempersiapkan tubuh dan mental secara optimal.'
				}
			/>
			<ArticleContainerPraKehamilan {...props} />
			{/* <ArticleDownloadContainer /> */}
		</>
	);
};

export const getServerSideProps: GetServerSideProps = wrapper.getServerSideProps(
	(store: any) => async (ctx) => {
		const { resolvedUrl } = ctx;
		const originalUrl = ctx.req.url;
		const slug = originalUrl?.split('?')[0].split('/').filter(Boolean);
		const hasUppercase = slug?.some((item: any) => item !== item.toLowerCase());

		const pathname = resolvedUrl;
		const dataBC = generateBreadcrumbArray(pathname);
		const dtUrlG: any = ctx.query.group;
		const dtUrl: any = ctx.query.category;
		const dtUrlPhase: any = ctx.query.phase;
		const toLower = (str: any) => str.toLowerCase();
		const dtPhase = toLower(dtUrlPhase);
		const dtCategory = toLower(dtUrl);
		const dtGroup = toLower(dtUrlG);
		const queryUrl = ctx.query;
		const queryPhase = dtPhase === 'pra-kehamilan' ? 'pre-pregnancy' : dtPhase === 'pasca-kehamilan' ? 'post-pregnancy' : 'pregnancy';
		const queryPhaseForGroup = dtPhase === 'pra-kehamilan' ? 'PH1' : dtPhase === 'pasca-kehamilan' ? 'PH3' : 'PH2';
		let isError: boolean = false;
		let artikelSec1: any = [];
		let artikelSec2: any = [];
		let artikelSec3: any = [];
		let categoryArtikel: any = [];
		let groupArtikel: any = [];
		let categoryExist: any;
		const queryClient = new QueryClient();
		const newFilter = 'orderby=desc&orderby=show_as_banner%2Cpublish_date%2Ctotal_like&page=1&per_page=4&show_as_banner=true';
		const filters = 'orderby=desc&orderby=show_as_banner%2Cpublish_date%2Ctotal_like&page=1&per_page=10&show_as_banner=false';
		// const filtersLike = 'order=desc&orderby=total_like&per_page=9&page=1';
		try {
			const urlGroup = `${g.API_ARTICLE_SLUG}/group?phase=${queryPhaseForGroup}`;
			const optsGroup = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			};

			const grp = await fetch(urlGroup, optsGroup);
			groupArtikel = await grp.json().then((res) => ({ ...res, status: grp.status }));

			const uriCategory = `${g.API_ARTICLE_SLUG}/categories?type=${queryPhase}&filter_groups=${dtGroup}&order=asc&orderBy=sequence&is_show=true&page=1&per_page=50`;
			const optsCategory = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			};

			const cat = await fetch(uriCategory, optsCategory);
			categoryArtikel = await cat.json().then((res) => ({ ...res, status: cat.status }));
			const staticTab = {
				slug: 'buat-mama',
				name: 'Buat Mama',
				media_images: { original: '/images/artikel/buat-mama.svg' },
				title: '',
			};
			const allTabs = [
				staticTab,
				...categoryArtikel.data.records?.slice(0) || [],
			];
			categoryExist = allTabs.some((item: any) => item.slug === dtCategory);
			const uri = `${g.API_ARTICLE}/${queryPhase}?group=${dtGroup}&category=${dtCategory === 'buat-mama' ? '' : dtCategory}&${newFilter}`;
			const opts = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			};

			const s1 = await fetch(uri, opts);
			artikelSec1 = await s1.json().then((res) => ({ ...res, status: s1.status }));

			const uriS2 = `${g.API_ARTICLE}/${queryPhase}?group=${dtGroup}&category=${dtCategory === 'buat-mama' ? '' : dtCategory}&${filters}`;
			const optsS2 = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			};

			const s2 = await fetch(uriS2, optsS2);
			artikelSec2 = await s2.json().then((res) => ({ ...res, status: s2.status }));

			const uriS3 = `${g.API_ARTICLE}/${queryPhase}?group=${dtGroup}&category=${dtCategory === 'buat-mama' ? '' : dtCategory}&${filters}`;
			const optsS3 = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			};

			const s3 = await fetch(uriS3, optsS3);
			artikelSec3 = await s3.json().then((res) => ({ ...res, status: s3.status }));

			if (hasUppercase === true) {
				return {
					redirect: {
						destination: `/artikel${dtPhase ? `/${dtPhase}` : ''}${dtGroup ? `/${dtGroup}` : ''}${dtCategory ? `/${dtCategory}` : ''}`,
						statusCode: 301,
					},
				};
			}

			if (categoryExist === false) {
				return {
					redirect: {
						destination: `/artikel${dtPhase ? `/${dtPhase}` : ''}${dtGroup ? `/${dtGroup}` : ''}/buat-mama`,
						statusCode: 301,
						permanent: false,
					},
				};
			}

		} catch (err: any) {
			if (err?.status === 400) {
				isError = true;
			} else {
				throw err;
			}
		}
		const article: IArticleByGroupDetail[] =
			store.getState().articleByGroup.articleByCategory?.data?.records;

		if (!article && isError) return { notFound: true };
		return {
			props: {
				dehydratedState: dehydrate(queryClient),
				card: true,
				isWhiteBackground: false,
				JsonLd: {
					organization: true,
					breadcrumbs: true,
				},
				pageHeaderContent: {
					title: 'pra kehamilan',
					breadcrumbs: [
						{ label: 'Artikel ', navigatePath: '/artikel' },
						{ label: 'Pra Kehamilan', navigatePath: '/pra-kehamilan' },
						{ label: dataBC[1].title, navigatePath: `/${dataBC[0].path}` + `/${dataBC[1].path}` },
					],
				},
				section1: artikelSec1.data.records || [],
				section2: artikelSec2.data.records || [],
				section3: artikelSec3.data.records || [],
				category: categoryArtikel.data.records || [],
				group: groupArtikel.data.records || [],
				phase: queryUrl.phase,
				categorySelected: queryUrl.category,
			},
		};
	},
);

export default CategoryArticle;
